// extracted by mini-css-extract-plugin
export default {"genericCard":"Uq-z","inline":"Vq-z","mastercard":"Wq-z","discover":"Xq-z","visa":"Yq-z","amex":"Zq-z","active":"_q-z"};